import { projectDocumentationService } from '../../services/projectDocumentationService.ts';

export const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

export const FETCH_SUBCATEGORIES_REQUEST = 'FETCH_SUBCATEGORIES_REQUEST';
export const FETCH_SUBCATEGORIES_SUCCESS = 'FETCH_SUBCATEGORIES_SUCCESS';
export const FETCH_SUBCATEGORIES_FAILURE = 'FETCH_SUBCATEGORIES_FAILURE';

export const FETCH_ALL_SUBCATEGORIES_REQUEST = 'FETCH_ALL_SUBCATEGORIES_REQUEST';
export const FETCH_ALL_SUBCATEGORIES_SUCCESS = 'FETCH_ALL_SUBCATEGORIES_SUCCESS';
export const FETCH_ALL_SUBCATEGORIES_FAILURE = 'FETCH_ALL_SUBCATEGORIES_FAILURE';

export const FETCH_USES_REQUEST = 'FETCH_USES_REQUEST';
export const FETCH_USES_SUCCESS = 'FETCH_USES_SUCCESS';
export const FETCH_USES_FAILURE = 'FETCH_USES_FAILURE';

export const FETCH_MATERIALITIES_REQUEST = 'FETCH_MATERIALITIES_REQUEST';
export const FETCH_MATERIALITIES_SUCCESS = 'FETCH_MATERIALITIES_SUCCESS';
export const FETCH_MATERIALITIES_FAILURE = 'FETCH_MATERIALITIES_FAILURE';

export const FETCH_FILE_TAGS_REQUEST = 'FETCH_FILE_TAGS_REQUEST';
export const FETCH_FILE_TAGS_SUCCESS = 'FETCH_FILE_TAGS_SUCCESS';
export const FETCH_FILE_TAGS_FAILURE = 'FETCH_FILE_TAGS_FAILURE';

export const SET_SELECTED_TYPE = 'SET_SELECTED_TYPE';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';
export const SET_SELECTED_SUBCATEGORY = 'SET_SELECTED_SUBCATEGORY';
export const SET_SELECTED_USES = 'SET_SELECTED_USES';
export const SET_SELECTED_MATERIALITIES = 'SET_SELECTED_MATERIALITIES';

export const SET_FORM_DATA = 'SET_FORM_DATA';
export const REPLACE_FORM_DATA = 'REPLACE_FORM_DATA';
export const RESET_FORM = 'RESET_FORM';

export const SET_SHOW_HEADER_SUMMARY = 'SET_SHOW_HEADER_SUMMARY';

export const SET_CREATION_PROGRESS_MODAL = 'SET_CREATION_PROGRESS_MODAL';
export const UPDATE_CREATION_PROGRESS = 'UPDATE_CREATION_PROGRESS';

export const CREATE_PROJECT_DOCUMENTATION_REQUEST = 'CREATE_PROJECT_DOCUMENTATION_REQUEST';
export const CREATE_PROJECT_DOCUMENTATION_SUCCESS = 'CREATE_PROJECT_DOCUMENTATION_SUCCESS';
export const CREATE_PROJECT_DOCUMENTATION_FAILURE = 'CREATE_PROJECT_DOCUMENTATION_FAILURE';

export const UPDATE_PROJECT_DOCUMENTATION_REQUEST = 'UPDATE_PROJECT_DOCUMENTATION_REQUEST';
export const UPDATE_PROJECT_DOCUMENTATION_SUCCESS = 'UPDATE_PROJECT_DOCUMENTATION_SUCCESS';
export const UPDATE_PROJECT_DOCUMENTATION_FAILURE = 'UPDATE_PROJECT_DOCUMENTATION_FAILURE';

export const FETCH_PROJECT_DOCUMENTATION_REQUEST = 'FETCH_PROJECT_DOCUMENTATION_REQUEST';
export const FETCH_PROJECT_DOCUMENTATION_SUCCESS = 'FETCH_PROJECT_DOCUMENTATION_SUCCESS';
export const FETCH_PROJECT_DOCUMENTATION_FAILURE = 'FETCH_PROJECT_DOCUMENTATION_FAILURE';

export const fetchCategories = () => async (dispatch) => {
  dispatch({ type: FETCH_CATEGORIES_REQUEST });
  try {
    const categories = await projectDocumentationService.getAllCategories();
    dispatch({ type: FETCH_CATEGORIES_SUCCESS, payload: categories });
  } catch (error) {
    dispatch({ type: FETCH_CATEGORIES_FAILURE, payload: error.message });
  }
};

export const fetchSubCategories = (categoryId) => async (dispatch) => {
  dispatch({ type: FETCH_SUBCATEGORIES_REQUEST });
  try {
    const subCategories = await projectDocumentationService.getSubCategoriesByCategoryId(categoryId);
    dispatch({ type: FETCH_SUBCATEGORIES_SUCCESS, payload: subCategories });
  } catch (error) {
    dispatch({ type: FETCH_SUBCATEGORIES_FAILURE, payload: error.message });
  }
};

export const fetchAllSubCategories = (categories) => async (dispatch) => {
  dispatch({ type: FETCH_ALL_SUBCATEGORIES_REQUEST });
  try {
    const allSubCategories = await projectDocumentationService.getAllSubCategories(categories);
    dispatch({ type: FETCH_ALL_SUBCATEGORIES_SUCCESS, payload: allSubCategories });
  } catch (error) {
    dispatch({ type: FETCH_ALL_SUBCATEGORIES_FAILURE, payload: error.message });
  }
};

export const fetchUses = () => async (dispatch) => {
  dispatch({ type: FETCH_USES_REQUEST });
  try {
    const uses = await projectDocumentationService.getAllUses();
    dispatch({ type: FETCH_USES_SUCCESS, payload: uses });
  } catch (error) {
    dispatch({ type: FETCH_USES_FAILURE, payload: error.message });
  }
};

export const fetchMaterialities = () => async (dispatch) => {
  dispatch({ type: FETCH_MATERIALITIES_REQUEST });
  try {
    const materialities = await projectDocumentationService.getAllMaterialities();
    dispatch({ type: FETCH_MATERIALITIES_SUCCESS, payload: materialities });
  } catch (error) {
    dispatch({ type: FETCH_MATERIALITIES_FAILURE, payload: error.message });
  }
};

export const fetchFileTags = () => async (dispatch) => {
  dispatch({ type: FETCH_FILE_TAGS_REQUEST });
  try {
    const fileTags = await projectDocumentationService.getAllFileTags();
    dispatch({ type: FETCH_FILE_TAGS_SUCCESS, payload: fileTags });
  } catch (error) {
    dispatch({ type: FETCH_FILE_TAGS_FAILURE, payload: error.message });
  }
};

export const setSelectedType = (projectType) => ({
  type: SET_SELECTED_TYPE,
  payload: projectType
});

export const setSelectedCategory = (categoryId) => ({
  type: SET_SELECTED_CATEGORY,
  payload: categoryId
});

export const setSelectedSubCategory = (subCategoryId) => ({
  type: SET_SELECTED_SUBCATEGORY,
  payload: subCategoryId
});

export const setSelectedUses = (useIds) => ({
  type: SET_SELECTED_USES,
  payload: useIds
});

export const setSelectedMaterialities = (materialityIds) => ({
  type: SET_SELECTED_MATERIALITIES,
  payload: materialityIds
});

export const setFormData = (formData) => ({
  type: SET_FORM_DATA,
  payload: formData
});

export const replaceFormData = (formData) => ({
  type: REPLACE_FORM_DATA,
  payload: formData
});

export const resetForm = () => ({
  type: RESET_FORM
});

export const createProjectDocumentation = (payload, items = [], onProgress) => async (dispatch) => {
  dispatch({ type: CREATE_PROJECT_DOCUMENTATION_REQUEST });
  try {
    const result = await projectDocumentationService.createProjectDocumentationComplete(payload, items, onProgress);
    dispatch({ type: CREATE_PROJECT_DOCUMENTATION_SUCCESS, payload: result });
    return result;
  } catch (error) {
    dispatch({ type: CREATE_PROJECT_DOCUMENTATION_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateProjectDocumentation = (id, payload, items = []) => async (dispatch) => {
  dispatch({ type: UPDATE_PROJECT_DOCUMENTATION_REQUEST });
  try {
    // Enviar el payload directamente como JSON (application/json)
    const result = await projectDocumentationService.updateProjectDocumentation(id, payload);
    
    // Si hay items (archivos), subirlos por separado después de actualizar
    if (items && items.length > 0) {
      await projectDocumentationService.uploadProjectDocumentationFiles(Number(id), items);
    }
    
    dispatch({ type: UPDATE_PROJECT_DOCUMENTATION_SUCCESS, payload: result });
    return result;
  } catch (error) {
    dispatch({ type: UPDATE_PROJECT_DOCUMENTATION_FAILURE, payload: error.message });
    throw error;
  }
};

export const fetchProjectDocumentation = (id) => async (dispatch) => {
  dispatch({ type: FETCH_PROJECT_DOCUMENTATION_REQUEST });
  try {
    const projectDoc = await projectDocumentationService.getProjectDocumentationById(id);
    dispatch({ type: FETCH_PROJECT_DOCUMENTATION_SUCCESS, payload: projectDoc });
    return projectDoc;
  } catch (error) {
    dispatch({ type: FETCH_PROJECT_DOCUMENTATION_FAILURE, payload: error.message });
    throw error;
  }
};

export const setShowHeaderSummary = (show) => ({
  type: SET_SHOW_HEADER_SUMMARY,
  payload: show
});

export const setCreationProgressModal = (config) => ({
  type: SET_CREATION_PROGRESS_MODAL,
  payload: config
});

export const updateCreationProgress = (progress) => ({
  type: UPDATE_CREATION_PROGRESS,
  payload: progress
});

export const FETCH_USER_PROJECT_DOCUMENTATIONS_REQUEST = 'FETCH_USER_PROJECT_DOCUMENTATIONS_REQUEST';
export const FETCH_USER_PROJECT_DOCUMENTATIONS_SUCCESS = 'FETCH_USER_PROJECT_DOCUMENTATIONS_SUCCESS';
export const FETCH_USER_PROJECT_DOCUMENTATIONS_FAILURE = 'FETCH_USER_PROJECT_DOCUMENTATIONS_FAILURE';

export const DELETE_PROJECT_DOCUMENTATION_REQUEST = 'DELETE_PROJECT_DOCUMENTATION_REQUEST';
export const DELETE_PROJECT_DOCUMENTATION_SUCCESS = 'DELETE_PROJECT_DOCUMENTATION_SUCCESS';
export const DELETE_PROJECT_DOCUMENTATION_FAILURE = 'DELETE_PROJECT_DOCUMENTATION_FAILURE';

export const fetchUserProjectDocumentations = (userId, forceRefetch = false) => async (dispatch, getState) => {
  if (!userId) {
    console.warn('fetchUserProjectDocumentations called without userId');
    return [];
  }

  const state = getState();
  const currentDocumentations = state.anteProyecto.userDocumentations;
  const isLoading = state.anteProyecto.userDocumentationsLoading;
  const lastFetchedUserId = state.anteProyecto.lastFetchedUserId;

  if (!forceRefetch && lastFetchedUserId === userId && currentDocumentations.length > 0 && !isLoading) {
    return currentDocumentations;
  }

  dispatch({ type: FETCH_USER_PROJECT_DOCUMENTATIONS_REQUEST });
  try {
    const documentations = await projectDocumentationService.getUserProjectDocumentations(userId);
    dispatch({ 
      type: FETCH_USER_PROJECT_DOCUMENTATIONS_SUCCESS, 
      payload: { documentations, userId } 
    });
    return documentations;
  } catch (error) {
    dispatch({ type: FETCH_USER_PROJECT_DOCUMENTATIONS_FAILURE, payload: error.message });
    throw error;
  }
};

export const deleteProjectDocumentation = (id) => async (dispatch) => {
  dispatch({ type: DELETE_PROJECT_DOCUMENTATION_REQUEST });
  try {
    await projectDocumentationService.deleteProjectDocumentation(id);
    dispatch({ type: DELETE_PROJECT_DOCUMENTATION_SUCCESS, payload: id });
    return { success: true };
  } catch (error) {
    dispatch({ type: DELETE_PROJECT_DOCUMENTATION_FAILURE, payload: error.message });
    throw error;
  }
};

